
export enum EslCd {
	REGULAR = 'Regular',
	SOLO = 'Solo'}

